import { omit } from "@mixitone/util";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { ButtonKind, ButtonClassesOptions, buttonClasses } from "../Styles/Buttons";
import { Spinner } from "./Spinner";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  kind?: ButtonKind;
  round?: boolean;
  compact?: boolean;
  spinner?: boolean;
  className?: string;
  noBorder?: boolean;
  groupPosition?: "left" | "middle" | "right";
  ref?: React.Ref<HTMLButtonElement>;
}

export const Button: React.FC<ButtonProps> = ({ ref, ...props }) => {
  const classes = twMerge(
    "relative",
    buttonClasses({
      kind: props.kind || "primary",
      className: props.className || "",
      groupPosition: props.groupPosition,
      round: props.round,
      compact: props.compact,
    }),
  );

  return (
    <button {...omit(props, ["spinner", "groupPosition", "round", "compact"])} className={classes} ref={ref}>
      <span className={clsx("mx-auto flex items-center gap-1", { "opacity-30": props.spinner })}>
        {props.children}
      </span>
      {props.kind === "select" && (
        <span className={"absolute top-1/2 right-2 -translate-y-1/2"}>
          <svg className="h-4 w-4" viewBox="0 0 20 20">
            <path d="M5.05 7.05a.5.5 0 01.71 0L10 11.29l4.24-4.24a.5.5 0 01.71.71l-4.5 4.5a.5.5 0 01-.71 0l-4.5-4.5a.5.5 0 010-.71z" />
          </svg>
        </span>
      )}
      {props.spinner && (
        <div className="absolute left-0 flex w-full items-center justify-center" style={{ margin: 0 }}>
          <Spinner size={16} />
        </div>
      )}
    </button>
  );
};

// Re-export for backward compatibility
export type { ButtonKind } from "../Styles/Buttons";
